<template>
  <div class="text-courseware-page">
    <!-- 顶部Banner -->
    <Banner />
    <div class="content-wrapper">
      <div class="left-list">
        <!-- 分类导航 -->
        <nav-filter />
        <!-- 面包屑 -->
        <div class="breadcrumb-bar">
          <button class="breadcrumb-back" @click="$router && $router.back ? $router.back() : window.history.back()">返回</button>
          <span class="breadcrumb-link">万知学习</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ guidInfo.belong_cn }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-link">{{ guidInfo.schoolname }}</span>
          <span class="breadcrumb-separator">/</span>
          <span class="breadcrumb-current">校园信息公告列表</span>
        </div>
        <!-- 列表 -->
        <div class="gonggao-list" v-if="list.length > 0">
            <div class="gonggao-item" v-for="item in list" :key="item.id" @click="handleClickDetail(item.id)">
              <div class="gonggao-item-top">
                <div class="gonggao-item-title">{{item.title}}</div>
                <div class="gonggao-item-time">发布时间：{{item.inputtime}}</div>
              </div>
              <div class="gonggao-item-content">{{item.content}}</div>
            </div>
          </div>
        <div v-if="list.length === 0" class="no-data">暂无数据</div>
        <!-- 分页 -->
        <el-pagination
          background
          layout="prev, pager, next"
          :total="total"
          :page-size="pageSize"
          :current-page="page"
          @current-change="handlePageChange"
          class="pagination-bar"
        />
      </div>
      <div class="right-news">
        <!-- <ad-sidebar /> -->
        <v-right :marketBannerSmall="marketBannerSmall" :marTop="false"></v-right>
      </div>
    </div>
  </div>
</template>

<script>
import sign from '@/auth/sign'
import Banner from '@/components/common/Banner.vue'
// import AdSidebar from '@/components/common/AdSidebar'
import vRight from '@/components/education/Right2'
import NavFilter from '@/components/teacher/NavFilter.vue'
import { getschoolNoticeLists, getEduDetails } from '@/axios/education'
export default {
  name: 'TextCourseware',
  components: {
    Banner,
    // AdSidebar,
    vRight,
    NavFilter
  },
  data () {
    return {
      list: [],
      page: 1,
      pageSize: 10,
      total: 0,
      teacher_id: parseInt(this.$route.query.teacher_id) || 1,
      type: 1,
      guidInfo: {
        name: '',
        zhiwu: ''
      }
    }
  },
  computed: {
    marketBannerSmall () {
      return this.$store.getters.travleBanner.sbanner
    }
  },
  created () {
    this.getguidInfo()
    this.getLists()
  },
  methods: {
    getguidInfo () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        id: this.teacher_id,
        type: 2
      }
      const signO = sign(params)
      params.sign = signO
      getEduDetails(params).then(res => {
        if (res.data.code === 200) {
          const data = res.data.data
          this.guidInfo = {
            belong_cn: data.belong_cn || '',
            schoolname: data.schoolname || ''
          }
        }
      })
    },
    getLists () {
      const params = {
        appid: 'wzwebapp',
        timestamp: parseInt(new Date().getTime() / 1000),
        school_id: this.teacher_id,
        stype: 2,
        ntype: 2,
        page: this.page
      }
      const signO = sign(params)
      params.sign = signO
      getschoolNoticeLists(params).then(res => {
        if (res.data.msg === '请求成功') {
          const data = res.data.data
          this.list = data.lists || []
          this.total = data.total || 0
        } else {
          this.list = []
          this.total = 0
        }
      }).catch(() => {
        this.list = []
        this.total = 0
      })
    },
    handleClickDetail (id) {
      this.$router.push({ name: 'NoticeDetail', query: { id, type: this.type } })
    },
    handlePageChange (page) {
      this.page = page
      this.getLists()
    }
  }
}
</script>

<style lang="less" scoped>
.text-courseware-page {
  background: #fff;
  padding-bottom: 20px;
}
.content-wrapper {
  display: flex;
  margin-top: 20px;
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.left-list {
  flex: 1;
  margin-right: 20px;
}
.right-news {
  width: 320px;
}
.breadcrumb-bar {
  display: flex;
  align-items: center;
  background: #F9F9F9;
  border-radius: 6px;
  padding: 8px 18px;
  margin-bottom: 16px;
  font-size: 14px;
}
.breadcrumb-back {
  border: 1px solid #e5e5e5;
  background: #fff;
  color: #888;
  border-radius: 4px;
  padding: 2px 10px;
  margin-right: 16px;
  height: 28px;
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s, border 0.2s;
  &:hover {
    background: #f2f2f2;
    border-color: #ccc;
  }
}
.breadcrumb-link {
  color: #666;
}
.breadcrumb-separator {
  color: #ccc;
  margin: 0 4px;
}
.breadcrumb-current {
  color: #EF8432;
  font-weight: bold;
}
.pagination-bar {
  text-align: center;
  margin-top: 20px;
}
.no-data {
  text-align: center;
  color: #aaa;
  margin: 30px 0;
}
.gonggao-list {
  .gonggao-item {
    padding: 16px;
    border-bottom: 1px solid #F0F0F0;
    cursor: pointer;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      background: #F8F8F8;
      .gonggao-item-title {
        color: #3FBABE;
      }
    }

    .gonggao-item-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 2px;

      .gonggao-item-title {
        font-size: 16px;
        color: #333333;
        font-weight: 500;
        transition: color 0.3s;
      }

      .gonggao-item-time {
        font-size: 14px;
        color: #999999;
      }
    }

    .gonggao-item-content {
      font-size: 14px;
      color: #666666;
      line-height: 1.6;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/teacher/noticeList.vue